import { type Node } from "prosemirror-model";

import { type NodeWithPos } from "../types";

type findDescendantsPredicate = (node: Node) => boolean;

export function findDescendants(node: Node, predicate: findDescendantsPredicate = () => true) {
	const descendants: NodeWithPos[] = [];

	node.descendants((node, pos) => {
		if (predicate(node)) {
			descendants.push({ node, pos });
		}
	});

	return descendants;
}
